function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(32 32) scale(1.12) translate(-32 -32)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 8h20l12 12v32c0 2.2-1.8 4-4 4H18c-2.2 0-4-1.8-4-4V12c0-2.2 1.8-4 4-4z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinejoin: "round",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 8v10c0 1.1.9 2 2 2h10",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinejoin: "round",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 30h20",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 40h20",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 50h14",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4.5,
  strokeLinecap: "round"
}));

var SvgIFullorder = function SvgIFullorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIFullorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_fullorder.83b02858.svg";
export { ForwardRef as ReactComponent };